export function generatePostDraftId(userId: string, tokenName: string, postId?: string, parentPostId?: string): string {
    const postid = postId ? `-${postId}` : '';
    const parentpostId = parentPostId ? `-parentPostId:${parentPostId}` : '';
    return `${userId}-${tokenName}${postid}${parentpostId}`;
}
